import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { resetOffer } from 'slices/offerSlice';
import noPoints from '../../assets/not-points.svg';

const NoPoints = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const HandleExit = () => {
    dispatch(resetOffer());
    navigate('/');
  };

  const { buttonText, buttonLink,
    imageLink } = useSelector((state) => state.offer.offer.buttonInfo);

  return (
    <Container className="bg-white">
      <Row className="pb-60 py-60">

        <Col lg={9} className="text-center">
          <h2 className="mb-15 text-tangaroa">¡Lo sentimos!</h2>
          <h3 className="px-60">
            En este momento no cuentas con Puntos suficientes para poder participar en la
            Subasta. Sigue acumulando Puntos Aeroméxico Rewards.
          </h3>
          <img src={noPoints} alt="noPoints-img" />
          <h4 className="mb-30 text-boulder-light">Ingresa aquí para conocer donde puedes seguir acumulando Puntos.</h4>
          <a href="https://www.aeromexicorewards.com/mx/acumula-puntos-premier" target="blank" className="btn btn-primary mb-15" id="sbs-dsb-dgr-btn-mor">
            Conoce más
          </a>
          <div className="d-flex justify-content-center">
            <button type="button" className="link mb-15 d-block btn-link-underline" id="sbs-dsb-dgr-btn-mor" onClick={HandleExit}>
              En otro momento
            </button>
          </div>
        </Col>
        <Col lg={3} className="mt-30 mt-sm-0">
          <div className="text-white multiply-banner">
            <a href={buttonLink} target="blank" className="btn btn-primary mt-30">
              {buttonText}
            </a>
            <img src={imageLink} alt={imageLink} className="w-100" />
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default NoPoints;
